import { useState, useEffect } from 'react';
import { STORAGE_KEYS } from '../constants';

export const useLocalStorage = (key, initialValue) => {
  // 初期値の取得
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.log(error);
      return initialValue;
    }
  });

  // 値が変更されたらローカルストレージを更新
  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(storedValue));
    } catch (error) {
      console.log(error);
    }
  }, [key, storedValue]);

  return [storedValue, setStoredValue];
};

// クイズデータ用のユーティリティ関数
export const clearQuizData = () => {
  Object.values(STORAGE_KEYS).forEach(key => localStorage.removeItem(key));
};

export const saveQuizData = (data, index, length, num) => {
  localStorage.setItem(STORAGE_KEYS.QUESTIONS, JSON.stringify(data));
  localStorage.setItem(STORAGE_KEYS.CURRENT_INDEX, index);
  localStorage.setItem(STORAGE_KEYS.LENGTH, length);
  localStorage.setItem(STORAGE_KEYS.CURRENT_NUM, num);
};

// クイズデータ用のカスタムフック
export const useQuizStorage = () => {
  return {
    clearQuizData,
    saveQuizData
  };
}; 
